import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=56994d46&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=56994d46&prod&lang=scss&scoped=true&"
import style1 from "./Menu.vue?vue&type=style&index=1&id=56994d46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56994d46",
  null
  
)

export default component.exports